import { render, staticRenderFns } from "./local.vue?vue&type=template&id=8521c916&scoped=true&"
import script from "./local.vue?vue&type=script&lang=js&"
export * from "./local.vue?vue&type=script&lang=js&"
import style0 from "./local.vue?vue&type=style&index=0&id=8521c916&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8521c916",
  null
  
)

export default component.exports